import * as _ from 'lodash';
import * as reportLimits from '../reports/reportLimits';

angular.module("tromanWeb").controller('EmailListController', ['persons', 'reportService', 'downloadService', '$uibModalInstance', function (persons, reportService, downloadService, $uibModalInstance) {

    this.$onInit = function () {
        this.persons = persons;
        this.kind = 'public';
        this.separator = ';';
        this.emails = [];
        this.receivers = '';
        this.missing = [];
        this.noreceiver = '';
        this.format = 1;

        this.calculateEmails();
    };

    function getPublicEmails(person) {
        if (person.emailPublic && person.emailPublic.Email) {
            var email = person.emailPublic.Email.trim();
            if (email.length > 0) {
                return [email];
            }
        }
        return [];
    }

    function getMessageEmails(person) {

        function includeEmail(list, obj) {
            if (obj && obj.UseForMessages && obj.Email) {
                var email = obj.Email.trim();
                if (email.length > 0)
                    list.push(email);
            }
        }

        var ret = [];
        includeEmail(ret, person.emailPublic);
        includeEmail(ret, person.emailInternal);
        includeEmail(ret, person.emailPrivate);
        return ret;
    }

    function getAllEmails(person) {

        function includeEmail(list, obj) {
            if (obj && obj.Email) {
                var email = obj.Email.trim();
                if (email.length > 0)
                    list.push(email);
            }
        }

        var ret = [];
        includeEmail(ret, person.emailPublic);
        includeEmail(ret, person.emailInternal);
        includeEmail(ret, person.emailPrivate);
        return ret;
    }

    this.calculateEmails = function calculateEmails() {
        var getEmails = (this.kind === 'public') ? getPublicEmails : (this.kind === 'message') ? getMessageEmails : getAllEmails;
        var emails = [];
        var missing = [];

        _.forEach(persons, x => {
            var pes = getEmails(x);
            if (pes.length > 0) {
                emails.push(pes);
            } else {
                missing.push(x);
            }
        });

        this.emails = _.flatten(emails);
        this.missing = missing;
        this.receivers = this.emails.join(this.separator);
        this.noreceiver = this.missing.map(x => x.name).join(', ');
        if (this.missing.length > reportLimits.MaxPersonIds) {
            this.error = 'Kan inte skapa etiketter till fler än ' + reportLimits.MaxPersonIds + ' personer.';
        } else {
            this.error = null;
        }
    };

    this.kindChanged = function () {
        this.calculateEmails();
    };

    this.separatorChanged = function () {
        this.receivers = this.emails.join(this.separator);
    };

    this.ok = function ok() {
        $uibModalInstance.close(true);
    };

    this.canGenerateLabels = function canGenerateLabels() {
        return this.missing.length > 0 && this.missing.length <= reportLimits.MaxPersonIds;
    };

    this.generateLabels = function generateLabels() {

        if (!this.canGenerateLabels()) return;

        this.isSaving = true;
        this.error = null;

        reportService
            .getPersonReports()
            .then(reports => {
                const report = _.find(reports, x => x.Id === 'Label_70x36');
                const args = reportService.getDefaultArguments(report);
                args.Query.PersonIds = this.missing.map(x => x.Id);
                args.Options.Format = this.format;

                return reportService
                    .generate(report.Id, args)
                    .finally(() => this.isSaving = false)
                    .then(rsp => downloadService.downloadBlob(rsp.blob, rsp.filename));
            })
            .catch(err => void (this.error = err));
    };
}]);
